import { Button } from '../../../shared/ui/button'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { mpCardRoutes } from '../../../../common/mpCardRoutes'
import { ReactComponent as AddIcon } from '../../../../assets/addIcon.svg'

type TargetType = 'CREATE' | 'EDIT'

interface CardActionButtonProps {
  target: TargetType

  isActive: boolean
}

export const CardActionButton = ({target, isActive}: CardActionButtonProps) => {
  const history = useHistory()

  const handleClick = () => {
    history.push(target === 'CREATE' ? mpCardRoutes.newCard.route({}) : mpCardRoutes.editCards.route({}))
  }

  return <Button icon={target === 'CREATE' && <AddIcon className={'white_svg'}/>} onClick={handleClick}
                 isActive={isActive} width={168}>
    <span>{target === 'CREATE' ? 'Создать карточку' : 'Редактировать'}</span>
  </Button>
}